namespace TabAurous.Purchase {
    export namespace PurchaseQuotationSelectItemsService {
        export const baseUrl = 'Purchase/PurchaseQuotationSelectItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<QuotationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Purchase/PurchaseQuotationSelectItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>PurchaseQuotationSelectItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
